import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

import video1 from '../assets/video/1.webm';
import video2 from '../assets/video/2.webm';
import video7 from '../assets/video/7.webm';
import video8 from '../assets/video/8.webm';
import video3 from '../assets/video/3.mp4';
import video4 from '../assets/video/4.mp4';
import video5 from '../assets/video/5.mp4';
import video6 from '../assets/video/6.mp4';

const InternProjects = () => {
  const videoRef = useRef(null);

  const playFullscreen = () => {
    const videoElement = videoRef.current;

    if (videoElement) {
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) {
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) {
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) {
        videoElement.msRequestFullscreen();
      }

      // Start playing the video
      videoElement.play();
    }
  };

  return (
    <div className='mt-5'>
      <motion.div
        // className="md:w-1/3"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <section className='grid grid-cols-1 lg:grid-cols-4 '>
          <div className='mx-5'>
            <div>
              <video

                src={video1}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <Link
              className="w-full text-center bg-teal-300 py-2"
              //  to='/eventsliner'
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </Link>
          </div>
          <div className='mx-5'>
            <div>
              <video

                src={video2}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="https://admin.eventsliner.com/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>
          <div className='mx-5'>
            <div>
              <video

                src={video3}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="http://34.131.247.223/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>
          <div className='mx-5'>
            <div>
              <video

                src={video4}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="http://34.131.247.223/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>
          <div className='mx-5 mt-5'>
            <div>
              <video

                src={video5}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="http://34.131.247.223/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>
          <div className='mx-5 mt-5'>
            <div>
              <video

                src={video6}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="http://34.131.247.223/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>
          <div className='mx-5 mt-5'>
            <div>
              <video

                src={video7}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="http://34.131.247.223/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>
          <div className='mx-5 mt-5'>
            <div>
              <video

                src={video8}
                controls
                alt='img'
                className='w-full h-[150px]'
                onClick={playFullscreen}
              />
            </div>
            <a
              className="w-full text-center bg-teal-300 py-2"
              // href="http://34.131.247.223/"
              // target="_blank"
              rel="noreferrer"
            >
              <button className='w-full text-center text-teal-900 font-bold text-md'>Details</button>
            </a>
          </div>

        </section></motion.div>
      <div className='m-5 text-center'>loading ....</div>
      <div className='flex justify-center text-blue mt-12 text-xl font-bold'>
        <Link to='/allinternwork'>See all</Link>
      </div>
    </div>
  );
};

export default InternProjects;
